import { render, staticRenderFns } from "./choseCourse.vue?vue&type=template&id=203db8ab&scoped=true&"
import script from "./choseCourse.vue?vue&type=script&lang=js&"
export * from "./choseCourse.vue?vue&type=script&lang=js&"
import style0 from "./choseCourse.vue?vue&type=style&index=0&id=203db8ab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203db8ab",
  null
  
)

export default component.exports